/**
 * @fileoverview Assist Check-in Disconnect Notice Modal
 * 
 * Displays a notification modal when an assisting proctor is disconnected from a session
 * because the primary proctor has left the check-in.
 * 
 * @module vtc/components/Modal/AssistCheckinDisconnectNotice
 */
import { Heading, CloseButton, Button, Modal } from '@smarterservices/smarter-ui';

/**
 * AssistCheckinDisconnectNotice Component
 * 
 * Modal that informs an assisting proctor that they are being disconnected from a session
 * because the primary proctor who was checking in the session has disconnected.
 * This modal cannot be dismissed by clicking outside and requires explicit user action.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.show - Controls modal visibility
 * @param {Function} props.onClose - Callback function when modal is closed (via button or close icon)
 * @returns {JSX.Element} Modal component
 * 
 * @example
 * <AssistCheckinDisconnectNotice
 *   show={showModal}
 *   onClose={handleClose}
 * />
 */
const AssistCheckinDisconnectNotice = (props) => {
    return (
        <Modal
            open={props.show}
            label="Assistance Disconnected Notice"
            shouldCloseOnDocumentClick={false}
            mountNode={() => document.getElementById('FocusModeContainer')}
            insertAt="top"
            constrain="parent"
        >
            <Modal.Header>
                <CloseButton
                    placement="end"
                    offset="small"
                    onClick={() => props.onClose()}
                    screenReaderLabel="Close"
                />
                <Heading>Assistance Disconnected Notice</Heading>
            </Modal.Header>
            <Modal.Body>
                The proctor checking in this session has disconnected, since you joined the session as an assistant you are also being disconnected.
            </Modal.Body>
            <Modal.Footer>
                <Button color="primary" type="submit" onClick={() => props.onClose()}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssistCheckinDisconnectNotice;
